import React from 'react'
// libs
import { useMutation } from '@apollo/client/react'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// graphql
import { SYNC_ACTIVE_DIRECTORY } from 'graphql/active-directory/mutations'

const SyncActiveDirectories: React.FC = () => {
  const [syncActiveDirectory, { loading }] = useMutation(SYNC_ACTIVE_DIRECTORY)

  const onClick = () => {
    syncActiveDirectory()
  }

  return (
    <Button style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE} onClick={onClick} isLoading={loading}>
      Sync
    </Button>
  )
}

export default SyncActiveDirectories
